module.exports = __webpack_public_path__ + "img/spinner_white.86ec94ee.svg";